import styled from "@emotion/styled";
import { units } from "../../../types/units";

export const TitleStyled = styled.h1`
  margin-right: 2rem;
  font-family: ${(props) => props.theme.fontFamily.primary};
  ${units({
    fontWeight: "bold",
    fontSize: "h3",
  })};
`;
